import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal, Pagination, Switch, Table, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { size as length, get, includes, isEmpty, isEqual, join } from 'lodash';
import { grid_columns_map } from './grid-configs';
import { EditActionCell, SelectAllButton } from '@med-fe/ui';
import styles from './BaseGrid.module.scss';
import {
  getDoctorsForGrid,
  getDoctor,
  getDoctorsWithSpecialRanges,
  getODDataIncomplete,
  getSelectedRow,
  getIsHooChangedAction,
  getDoctorsWithLiveRanges,
} from '../../pace/pace-selectors';
import { fetchSelectedDoctor, setSelectedRow } from '../../pace/pace-actions';
import { getFirstDayOfCurrentMonth } from '../../common/helpers/date';
import EmployeePattern from './components/employee-pattern/EmployeePattern';
import { getImportValidationData, getTemplates, getValidationErrors } from '../templates/templates-selector';
import { useGridSelectionBulk } from './hooks/use-grid-selection-bulk';
import { SpecialRangesEditBtn } from './components/SpecialRangesEditBtn';
import useToggleDrawerVisibility from './hooks/use-toggle-drawer-visibility';
import SpecialRangesDetails from './SpecialRangesDetails';
import { SpecialRangesBulkUpdateDrawer } from './components/SpecialRangesBulkUpdateDrawer';
import { getAuditForGrid } from '../audit/audit-reducer';
import { TemplatesActions } from '../templates/TemplatesActions';
import { getNewOfficesForGrid } from '../../pace/new-offices/new-offices-selectors';
import { SlotBulkUpdateDrawer } from './components/SlotBulkUpdateDrawer';
import styled from 'styled-components';
import { UnmappedGridActions } from './components/UnmappedGridActions';
import { getException } from '../ExceptiopnManagement/selectors';
import menuStyles from '../navbar/navbarMenu.module.scss';
import ExceptionDetails from '../ExceptiopnManagement/ExceptionDetails';
import moment from 'moment';
import { exceptionColumn } from './grid-configs/unmappedOds';
import { getResourcesForGrid, getResourcesFromFile } from '../ResourceCleanup/resources-reducer';
import { getTemplateAccomodations } from '../TemplatesAccommodations/selectors';

import {
  validateFile,
  processCleanup,
  fetchResourceFileDetails,
  downloadFile,
  deleteFile,
} from '../ResourceCleanup/resources-action';
import { ResourceDetails } from '../ResourceCleanup/ResourceDetails';
import TemplateAccomodationDetails from '../TemplatesAccommodations/TemplateAccomodationDetails';
import AddRampDrawer from '../schedule-ramps/AddRampDrawer';
import { api } from '@med-fe/util';
import { LiveRangeDataItem } from '../templates/template-details/details/MainInfo';
import AddRampAssignmentDrawer from '../schedule-ramps/AddRampAssignmentDrawer';
import { clearAssignmentModal } from '../schedule-ramps/ramps-actions';
import { EditOutlined, CopyOutlined } from '@ant-design/icons';

interface IDoctorInfo {
  employeeId: string;
  name: string;
  office: string;
  officeName: string;
}

interface baseGridTypes {
  id: any;
  total: any;
  search: any;
  setSearch: any;
  loading: any;
  isPagination?: any;
  rowKey?: any;
  rowSelection?: any;
  onlyTotalCount?: any;
  setIsAllSelected?: any;
  setIsSearch?: any;
  showException?: any;
  setShowException?: any;
  selected?: any[];
  // allow setSelected to accept either an array or an updater function
  setSelected?: (rows: any[] | ((prev: any[]) => any[])) => void;
  selectedKeys?: any[];
  data?: any[];
  columns?: any[];
  pageSizeOptions?: any[];
  hidePaginationControls?: boolean;
  tableScroll?: any;
  paginationExtra?: any;
  base?: any;
  setParentSelected?: (rows: any[]) => void;
  paginationLeftExtra?: any;
  readOnly?: boolean;
}

function BaseGrid({
  id,
  total,
  search,
  setSearch,
  loading,
  isPagination,
  rowKey,
  rowSelection,
  onlyTotalCount,
  setIsAllSelected,
  setIsSearch,
  showException,
  setShowException,
  selected = [],
  setSelected = () => {},
  selectedKeys = [],
  setParentSelected = () => {},
  data: providedData,
  columns: providedColumns,
  hidePaginationControls,
  tableScroll,
  pageSizeOptions,
  paginationExtra,
  paginationLeftExtra,
  readOnly = false,
}: baseGridTypes & { setParentSelected?: (rows: any[]) => void }) {
  const history = useHistory();
  const selectorMap: any = {
    unmappedOds: getDoctorsForGrid,
    liveRanges: getDoctorsWithLiveRanges,
    specialRanges: getDoctorsWithSpecialRanges,
    odDataIncomplete: getODDataIncomplete,
    templatesManagement: getTemplates,
    audit: getAuditForGrid,
    newOffices: getNewOfficesForGrid,
    templateRanges: getImportValidationData,
    assignTemplates: getImportValidationData,
    assignTemplateValidationErrors: getValidationErrors,
    templateMaintenance: getImportValidationData,
    exceptionManagement: getException,
    resourcecleanup: getResourcesForGrid,
    resourceFile: getResourcesFromFile,
    templatesAccommodations: getTemplateAccomodations,
  };

  const dispatch = useDispatch();
  const dataFromStore = useSelector((state) => (selectorMap[id] ? selectorMap[id](state) : []));
  const data = typeof providedData !== 'undefined' ? providedData : dataFromStore;

  const isUnmappedOdsTab = id === 'unmappedOds';
  const isSpecialRangesTab = id === 'specialRanges';
  const isLiveRangesTab = id === 'liveRanges';
  const isTemplatesManagementPage = id === 'templatesManagement';
  const isExceptionManagementPage = id === 'exceptionManagement';
  const { page, size, base } = search;
  const isNoSpecialRangesSubtab = isSpecialRangesTab && base === true;
  const selectedRow = useSelector(getSelectedRow);
  const doctor = useSelector(getDoctor);
  const isHooChangedAction = useSelector(getIsHooChangedAction);
  const [doctorInfo, setDoctorInfo] = useState<IDoctorInfo | null>(null);
  const [exceptionDrawer, setExceptionDrawer] = useState(false);
  const [selectedException, setSelectedException] = useState<string | undefined>(undefined);
  const [rowDetail, setRowDetail] = useState<any>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState<any>(null);
  const [isAssignmentDrawerVisible, setIsAssignmentDrawerVisible] = useState(false);
  const [assignmentModalData, setAssignmentModalData] = useState<any>(null);
  const assignmentModal = useSelector((state) => state?.rampsState?.assignmentModal);
  const [isCloneMode, setIsCloneMode] = useState(false);
  const gridIdentifier =
    id === 'specialRanges'
      ? `specialRanges${base ? 'Base' : 'All'}`
      : isUnmappedOdsTab && isHooChangedAction
      ? `${id}HooChanged`
      : id;

  const { isDrawerVisible, openDrawer, closeDrawer } = useToggleDrawerVisibility();
  // open assignment drawer when an external edit request is dispatched
  useEffect(() => {
    if (id === 'rampAssignments' && assignmentModal) {
      setAssignmentModalData(assignmentModal);
      setIsAssignmentDrawerVisible(true);
    }
  }, [assignmentModal, id]);
  const {
    onRow,
    selectedKeys: gridSelectedKeys,
    selectedItems,
    setSelected: setGridSelected,
    clearSelectedRows,
    isAllSelected,
    toggleIsAllSelected,
  } = useGridSelectionBulk({ data, search, gridId: id });

  // For templatesManagement, wire up checkbox selection
  if (id === 'templatesManagement') {
    window.setGridSelected = (checked, row, index) => {
      if (checked) {
        setSelected((prev: any[]) => [...prev, row]);
      } else {
        setSelected((prev: any[]) => prev.filter((it) => it.key !== row.key));
      }
    };
    window.selectedKeys = selectedKeys;
  }
  const isBulk =
    ((isAllSelected && length(selectedKeys) < total - 1) || (!isAllSelected && length(selectedKeys) > 1)) && base;
  const isSlotBulk = length(selectedKeys) > 0 && !base;
  if (isUnmappedOdsTab) {
    const found = grid_columns_map?.unmappedOds?.some((el) => el.title === 'Exception');
    if (!base) {
      if (!found) {
        grid_columns_map?.unmappedOds?.splice(1, 0, exceptionColumn);
      }
    } else {
      if (found) {
        grid_columns_map?.unmappedOds?.splice(1, 1);
      }
    }
  }
  if (isSpecialRangesTab) {
    const found = grid_columns_map?.specialRangesBase?.some((el) => el.title === 'Exception');
    if (!found && !showException) {
      grid_columns_map?.specialRangesBase?.splice(1, 0, exceptionColumn);
    } else if (found && showException) {
      grid_columns_map?.specialRangesBase?.splice(1, 1);
    }
    const allFound = grid_columns_map?.specialRangesAll?.some((el) => el.title === 'Exception');
    if (!allFound && !showException) {
      grid_columns_map?.specialRangesAll?.splice(1, 0, exceptionColumn);
    } else if (allFound && showException) {
      grid_columns_map?.specialRangesAll?.splice(1, 1);
    }
  }
  // allow conditional column filtering (eg. hide clone column when showing drafts)
  let gridCols: any[] =
    typeof providedColumns !== 'undefined' ? providedColumns : grid_columns_map[gridIdentifier] || [];
  if (isTemplatesManagementPage && search && search.drafts) {
    gridCols = gridCols.filter((c) => c.key !== 'cloneTemplate');
  }

  const columns = gridCols.map((col: any) => {
    const columnConfig = {
      ...col,
      ellipsis: true,
    };

    if (col.key === 'resourceValidation') {
      columnConfig['render'] = (text: string, record: any, rowIndex: any) => {
        return (
          <>
            <EditActionCell
              text={'Provider Templates'}
              record={record}
              disabled={record.processedOn !== null}
              onClickHandler={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(validateFile('PROVIDER_BLOCKS'));
              }}
            />
            <EditActionCell
              classname='validation-link-margin'
              text={'Service Templates'}
              record={record}
              disabled={record.processedOn !== null}
              onClickHandler={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(validateFile('SERVICE_TEMPLATE'));
              }}
            />
            <EditActionCell
              classname='validation-link-margin'
              text={'Service Template Details'}
              record={record}
              disabled={record.processedOn !== null}
              onClickHandler={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(validateFile('SERVICE_TEMPLATE_DETAILS'));
              }}
            />
          </>
        );
      };
    }
    if (col.key === 'processCleanup') {
      columnConfig['render'] = (text: string, record: any, rowIndex: any) => {
        if (record.processedOn == null)
          return (
            <>
              <Button
                type='primary'
                onClick={() => {
                  dispatch(processCleanup(record.id));
                }}
              >
                Process Cleanup
              </Button>
            </>
          );
        else
          return (
            <p>
              Processed by {record.processedBy} on {record.processedOn}
            </p>
          );
      };
    }

    if (col.key === 'download') {
      columnConfig['render'] = (text: string, record: any, rowIndex: any) => {
        return (
          <>
            <EditActionCell
              text={'Download File'}
              record={record}
              onClickHandler={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(
                  downloadFile({
                    address: record.fileAddress,
                    name: record.fileName,
                  })
                );
              }}
            />
          </>
        );
      };
    }
    if (col.key === 'deleteFile') {
      columnConfig['render'] = (text: string, record: any, rowIndex: any) => {
        return (
          <>
            <Button
              type='primary'
              disabled={record.processedOn !== null}
              onClick={() => {
                dispatch(deleteFile(record.id));
              }}
            >
              Delete
            </Button>
          </>
        );
      };
    }
    if (col.key === 'totalRows') {
      columnConfig['render'] = (text: string, record: any, rowIndex: number) => {
        const isProcessed = record.processedOn !== null;
        const isClickable = rowIndex === 0 && !isProcessed;

        const getFileDetails = (e: { preventDefault: () => void; stopPropagation: () => void }) => {
          e.preventDefault();
          e.stopPropagation();
          dispatch(fetchResourceFileDetails(''));
          setIsModalVisible(true);
        };

        if (isClickable) {
          return <EditActionCell text={`${record.totalRows}`} record={record} onClickHandler={getFileDetails} />;
        }

        return (
          <span
            style={{
              opacity: 0.5,
              cursor: 'not-allowed',
            }}
            title={isProcessed ? 'File already processed' : 'Only summary row is clickable'}
          >
            {record.totalRows}
          </span>
        );
      };
    }

    if (col.key === 'doctor' || col.key === 'exceptionEmployeeName') {
      columnConfig['render'] = (text: string, record: any, rowIndex: any) => {
        const onClickHandler = (e: { preventDefault: () => void; stopPropagation: () => void }) => {
          e.preventDefault();
          e.stopPropagation();
          //console.log(record);
          setDoctorInfo({
            employeeId: record.employeeId,
            name: record.employeeName,
            office: record.office,
            officeName: record.officeName,
            ...(record.reason && { reason: record.reason }),
          });

          if (id === 'specialRanges') {
            clearSelectedRows();
            toggleIsAllSelected(false);
            openDrawer();
          } else if (id === 'liveRanges') {
            let templateId = record.rangeNo;
            let rangeType = 'default';
            //console.log(search.path);
            if (search.path === undefined) rangeType = 'special';
            if (search && (search.path === 'mapped-special' || search.path === undefined)) {
              rangeType = 'special';
              const currentDate = moment();
              let apiStartDate = currentDate.format('YYYY-MM-DD');
              const fetchLiveRangeDataForEmployee = async () => {
                try {
                  const payload = {
                    page: 0,
                    size: 32,
                    employeeId: record.employeeId,
                    office: record.office,
                    startDate: apiStartDate,
                  };
                  const response: any = await api.post(
                    `/live-ranges/mapped-special?page=${payload.page}&size=${payload.size}  `,
                    payload,
                    null,
                    true,
                    false
                  );
                  // Transform response to LiveRangeDataItem array
                  const responseData = response?.contents || response?.content || response || [];
                  const dataArray = Array.isArray(responseData) ? responseData : [];
                  const liveRangeData: LiveRangeDataItem[] = dataArray
                    .filter(
                      (item: any) =>
                        String(item.employeeId) === String(record.employeeId) &&
                        String(item.office) === String(record.office)
                    )
                    .map((item: any) => ({
                      startDate: item.startDate,
                      templateId: item.rangeNo,
                      rangeNo: item.rangeNo || 0,
                      employeeId: item.employeeId,
                      office: item.office,
                    }));

                  history.push({
                    pathname: `/liveranges-management/details/${templateId}`,
                    search: `?from=liveRanges&range=${rangeType}`,
                    state: { liveRangeData },
                  });
                } catch (error) {
                  history.push(`/liveranges-management/details/${templateId}?from=liveRanges&range=${rangeType}`);
                }
              };
              fetchLiveRangeDataForEmployee();
            } else if (search && search.path === 'mapped-range0') {
              rangeType = 'range0';
              templateId = -1;
              if (readOnly) {
                history.push({
                  pathname: `/template-viewer/details/${templateId}`,
                  search: `?from=liveRanges&range=${rangeType}&employeeNum=${record.employeeId}&officeNum=${record.office}&dayOfWeek=${record.dayOfWeek}&templateName=${record.templateName}`,
                  state: { previousSearch: search },
                });
              } else {
                history.push(
                  `/liveranges-management/details/${templateId}?from=liveRanges&range=${rangeType}&employeeNum=${record.employeeId}&officeNum=${record.office}&dayOfWeek=${record.dayOfWeek}&templateName=${record.templateName}`
                );
              }
            }
          } else {
            dispatch(
              fetchSelectedDoctor({
                id: record.employeeId,
                office: record.office,
                base,
                startDate: getFirstDayOfCurrentMonth(),
              })
            );
          }
          dispatch(setSelectedRow(rowIndex));
        };

        return <EditActionCell text={text} status={record.status} onClickHandler={onClickHandler} />;
      };
    }
    if (id === 'rampDefinitions' && col.key === 'actions') {
      columnConfig['render'] = (text: string, record: any, rowIndex: any) => {
        const handleEditClick = (e: any) => {
          e.preventDefault();
          e.stopPropagation();
          setModalData(record);
          setIsCloneMode(false);
          openDrawer();
        };

        const handleCloneClick = (e: any) => {
          e.preventDefault();
          e.stopPropagation();
          setModalData(record);
          setIsCloneMode(true);
          openDrawer();
        };

        const hasAssignments = record && (record.hasAnyAssignments || record.HasAnyAssignments);

        return (
          <div style={{ display: 'flex', gap: 8 }}>
            {hasAssignments ? (
              <Tooltip placement='top' title='Clone'>
                <Button
                  style={{
                    backgroundColor: '#2E7D32',
                    border: 'none',
                    borderRadius: '5px',
                    width: '24px',
                    height: '25px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  icon={<CopyOutlined style={{ color: 'white', fontSize: 16 }} />}
                  onClick={handleCloneClick}
                />
              </Tooltip>
            ) : (
              <Tooltip placement='top' title='Edit'>
                <Button
                  style={{
                    backgroundColor: '#003366',
                    border: 'none',
                    borderRadius: '5px',
                    width: '24px',
                    height: '25px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  icon={<EditOutlined style={{ color: 'white', fontSize: 16 }} />}
                  onClick={handleEditClick}
                />
              </Tooltip>
            )}
          </div>
        );
      };
    }
    if (col.key === 'exceptionEmployeeName') {
      columnConfig['render'] = (text: string, record: any, rowIndex: any) => {
        const onClickHandler = (e: { preventDefault: () => void; stopPropagation: () => void }) => {
          e.preventDefault();
          e.stopPropagation();
          setExceptionDrawer(true);
          setSelectedException(record.exceptionId);
          setRowDetail(record);
        };

        return <EditActionCell text={text} record={record} onClickHandler={onClickHandler} />;
      };
    }

    return columnConfig;
  });

  // compute effective scroll: if there's no row data, avoid setting a vertical `y` height
  // because AntD will render an empty table body with a scrollbar even when there are no rows.
  const effectiveScroll = (() => {
    const defaultScroll = tableScroll || { x: '100%', y: 'calc(100vh - 17.5em)' };
    const hasRows = Array.isArray(data) && data.length > 0;
    if (!hasRows) {
      const x = defaultScroll && (defaultScroll.x || '100%');
      return { x };
    }
    return defaultScroll;
  })();

  const renderShowTotal = (totalCount: any) => {
    if (id === 'audit' || id === 'resourcecleanup') return undefined;
    return (
      <div style={{ display: 'flex' }} className='wrapper'>
        <div className={styles['total-container']}>
          {!isEmpty(selectedKeys) ? (
            <>
              <div className={styles['total-title']}>
                <div className={styles['total-selected-rows']}>
                  <span>{isAllSelected ? 'EXCLUDED' : 'SELECTED'}</span>
                  <span
                    onClick={() => {
                      setSelected([]);
                      try {
                        setParentSelected && setParentSelected([]);
                      } catch (e) {}
                    }}
                  >
                    <img src={'./icons/action-close.svg'} alt='close' />
                  </span>
                </div>
              </div>
              <div className={styles['total-count']}>
                <span>{join([length(selectedKeys), isAllSelected ? `/${totalCount}` : ''], '')}</span>
              </div>
            </>
          ) : (
            <>
              <div className={styles['total-title']}>TOTAL ENTRIES</div>
              <div className={styles['total-count']}>
                <span>{totalCount}</span>
              </div>
            </>
          )}
        </div>
        {isEqual(id, 'unmappedOds') && <UnmappedGridActions setSearch={setSearch} />}
        {isEqual(id, 'specialRanges') && (
          <>
            <Button
              type={base ? 'primary' : 'default'}
              htmlType='submit'
              className={`button ${base ? '' : 'ant-btn-default'}`}
              style={{ marginLeft: 20 }}
              onClick={onNoSpecialRangeClick}
            >
              NO SPECIAL RANGE
            </Button>
            <Button
              type={base ? 'default' : 'primary'}
              htmlType='submit'
              className={` ${base ? 'ant-btn-default' : ''}`}
              onClick={onAllClick}
            >
              ALL
            </Button>
          </>
        )}
        {isEqual(id, 'liveRanges') && !readOnly && (
          <>
            <Button
              type={base ? 'primary' : 'default'}
              htmlType='submit'
              className={`button ${base ? '' : 'ant-btn-default'}`}
              style={{ marginLeft: 20 }}
              onClick={onLiveSpecialRangesClick}
            >
              SPECIAL RANGE
            </Button>
            <Button
              type={base ? 'default' : 'primary'}
              htmlType='submit'
              className={` ${base ? 'ant-btn-default' : ''}`}
              onClick={onLiveRange0Click}
            >
              RANGE 0
            </Button>
          </>
        )}
      </div>
    );
  };

  const handleTableChange = (pagination, filters, sorter, extra) => {
    // sorter can be an array or object, handle accordingly
    if (Array.isArray(sorter)) {
      if (sorter.length > 0) {
        setSearch({ sorting: { field: sorter[0].field, order: sorter[0].order } });
      }
    } else {
      setSearch({ sorting: { field: sorter.field, order: sorter.order } });
    }
  };

  const onNoSpecialRangeClick = () => {
    setSearch({ page: 0, base: true, path: 'unmapped' });
    clearSelectedRows();
    setIsAllSelected(false);
    toggleIsAllSelected(false);
  };

  const onAllClick = () => {
    setSearch({ page: 0, base: false, path: 'mapped' });
    clearSelectedRows();
    setIsAllSelected(true);
    toggleIsAllSelected(false);
  };

  const onLiveSpecialRangesClick = () => {
    setSearch({ page: 0, base: true, path: 'mapped-special' });
    clearSelectedRows();
    setIsAllSelected(false);
    toggleIsAllSelected(false);
  };

  const onLiveRange0Click = () => {
    setSearch({ page: 0, base: false, path: 'mapped-range0' });
    clearSelectedRows();
    setIsAllSelected(false);
    toggleIsAllSelected(false);
  };

  return (
    <>
      <div className={styles['table-container']}>
        <div className={styles['table-wrapper']}>
          <Table
            rowKey={rowKey}
            className={styles['table-common']}
            rowClassName={(record, i) =>
              ((isSpecialRangesTab || isTemplatesManagementPage) &&
                ((!isAllSelected && includes(selectedKeys, record.key)) ||
                  (isAllSelected && !includes(selectedKeys, record.key)))) ||
              isEqual(i, selectedRow)
                ? 'table-selected-row'
                : isSpecialRangesTab || isUnmappedOdsTab
                ? record.exceptionData
                  ? menuStyles['red']
                  : ''
                : isExceptionManagementPage
                ? record?.endDate && moment(record?.endDate).isBefore(moment())
                  ? menuStyles['grey']
                  : ''
                : ''
            }
            onChange={isTemplatesManagementPage || isExceptionManagementPage ? handleTableChange : undefined}
            dataSource={data}
            columns={columns}
            pagination={false}
            loading={!isEmpty(doctor) ? false : loading}
            scroll={effectiveScroll}
            onRow={!readOnly && (isSpecialRangesTab || isTemplatesManagementPage) ? onRow : undefined}
            rowSelection={!readOnly ? rowSelection : undefined}
          />

          {!readOnly && isSpecialRangesTab && (isBulk || isSlotBulk) && <SpecialRangesEditBtn onClick={openDrawer} />}
          {!readOnly && id === 'exceptionManagement' ? (
            <Button
              className={`${styles['add-btn']} ${true ? '' : styles['disabled']}`}
              onClick={(e) => {
                e.preventDefault();
                setExceptionDrawer(true);
              }}
            >
              <img src={'./icons/action-add.svg'} alt='add' />
            </Button>
          ) : (
            ''
          )}
          {!readOnly && id === 'templatesManagement' && (
            <Button
              className={`${styles['add-btn']}`}
              onClick={(e) => {
                e.preventDefault();
                history.push('templates-management/details/0');
              }}
            >
              <img src={'./icons/action-add.svg'} alt='add' />
            </Button>
          )}
          {!readOnly && id === 'rampDefinitions' && (
            <Button
              className={`${styles['add-btn']}`}
              onClick={(e) => {
                e.preventDefault();
                setModalData(null);
                setIsCloneMode(false);
                openDrawer();
              }}
            >
              <img src={'./icons/action-add.svg'} alt='add' />
            </Button>
          )}
          {!readOnly && id === 'rampAssignments' && (
            <Button
              className={`${styles['add-btn']}`}
              onClick={(e) => {
                e.preventDefault();
                setIsAssignmentDrawerVisible(true);
                dispatch(clearAssignmentModal());
              }}
            >
              <img src={'./icons/action-add.svg'} alt='add' />
            </Button>
          )}
        </div>
        {onlyTotalCount && id != 'assignTemplateValidationErrors' && (
          <>
            <div className={styles['total-count-container']}>
              <div style={{ display: 'flex' }} className='wrapper'>
                <div className={styles['total-container']}>
                  <div className={styles['total-title']}>TOTAL ENTRIES</div>
                  <div className={styles['total-count']}>
                    <span>{total}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {!isPagination && (
          <div className={styles['pagination-container']}>
            {hidePaginationControls && id != 'assignTemplateValidationErrors' ? (
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                className='wrapper'
              >
                {renderShowTotal(total)}
                {paginationLeftExtra && (
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}>{paginationLeftExtra}</div>
                )}
                {paginationExtra && (
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}>{paginationExtra}</div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {renderShowTotal(total)}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {paginationLeftExtra && (
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 12 }}>{paginationLeftExtra}</div>
                  )}
                  <Pagination
                    current={page + 1}
                    defaultPageSize={size}
                    showSizeChanger
                    pageSizeOptions={pageSizeOptions || ['10', '20', '50', '100']}
                    total={total}
                    onChange={(pageNumber: number, pageSize: any) => {
                      // clear parent selection when page changes
                      try {
                        setParentSelected && setParentSelected([]);
                      } catch (e) {}
                      setSearch({ size: pageSize, page: size !== pageSize ? 0 : pageNumber - 1 });
                      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                      isSpecialRangesTab ? setIsSearch(true) : '';
                    }}
                  />
                  {paginationExtra && (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}>{paginationExtra}</div>
                  )}
                </div>
              </div>
            )}

            {isTemplatesManagementPage && (
              <TemplatesActions
                selectedKeys={selectedKeys}
                selectedRows={selected}
                clearSelectedRows={() => {
                  clearSelectedRows();
                  setParentSelected([]);
                }}
              />
            )}

            {isSpecialRangesTab && (
              <div className='archived-switch'>
                <label className='label-text'>{'Hide Exceptions'}</label>
                <Switch
                  size='small'
                  checked={showException}
                  onChange={(flag) => {
                    setShowException(flag);
                  }}
                  style={{ marginLeft: '5px' }}
                />
                {/* </Label> */}
              </div>
            )}
            {isNoSpecialRangesSubtab && (
              <WrapSelectAllButton>
                <SelectAllButton
                  whatSelect='doctors'
                  isAllSelected={isAllSelected}
                  onClick={() => {
                    toggleIsAllSelected();
                    clearSelectedRows();
                  }}
                />
              </WrapSelectAllButton>
            )}
            <img alt='logo' className={styles['logo']} src={'./images/logo.svg'} />
          </div>
        )}
      </div>

      {isUnmappedOdsTab && !isEmpty(doctor) && (
        <EmployeePattern doctor={doctor} doctorInfo={doctorInfo} search={search} />
      )}
      {isSpecialRangesTab && !isBulk && !isSlotBulk && isDrawerVisible && (
        <SpecialRangesDetails
          search={search}
          isVisible={isDrawerVisible}
          doctorInfo={doctorInfo}
          onClose={closeDrawer}
        />
      )}
      {isSpecialRangesTab && isBulk && isDrawerVisible && (
        <SpecialRangesBulkUpdateDrawer
          onClose={closeDrawer}
          clearSelectedRows={clearSelectedRows}
          selectedKeys={selectedKeys}
          selectedItems={selectedItems}
          isAllSelected={isAllSelected}
          total={total}
          isDrawerVisible={isDrawerVisible}
          hideException={showException}
        />
      )}
      {isSpecialRangesTab && isSlotBulk && isDrawerVisible && (
        <SlotBulkUpdateDrawer onClose={closeDrawer} selectedItems={selectedItems} isDrawerVisible={isDrawerVisible} />
      )}
      <ExceptionDetails
        id={id}
        excepId={selectedException}
        record={rowDetail}
        setRowDetail={setRowDetail}
        setSelectedException={setSelectedException}
        setExceptionDrawer={setExceptionDrawer}
        exceptionDrawer={exceptionDrawer}
        hideDetails={() => {
          setSelectedException(undefined);
          setExceptionDrawer(false);
          setRowDetail({});
        }}
      />
      <ResourceDetails
        visible={isModalVisible}
        tableId={'resourceFile'}
        onCancel={() => setIsModalVisible(false)}
      ></ResourceDetails>
      {id === 'rampDefinitions' && isDrawerVisible && (
        <AddRampDrawer
          open={isDrawerVisible}
          onClose={() => {
            closeDrawer();
            setModalData({});
            setIsCloneMode(false);
          }}
          modalData={modalData}
          isClone={isCloneMode}
        />
      )}

      {id === 'rampAssignments' && (
        <AddRampAssignmentDrawer
          open={isAssignmentDrawerVisible}
          modalData={assignmentModalData}
          onClose={() => {
            setIsAssignmentDrawerVisible(false);
            setAssignmentModalData(null);
            dispatch(clearAssignmentModal());
          }}
        />
      )}
    </>
  );
}

export default BaseGrid;

const WrapSelectAllButton = styled.div`
  display: flex;
  flex-grow: 1;
`;

declare global {
  interface Window {
    setGridSelected?: (checked: boolean, row: any, index: number) => void;
    selectedKeys?: any[];
  }
}
